var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var diagramConfiguration = require('../diagramConfiguration');
var editCustomEquipmentModal = require('../../../editCustomEquipmentModal');
var { bindingChannel } = require('../../bindingChannel');
var loaders = require('../../../../layout/components/loaders');
var createExternalConnectionAnnotations = require('./helpers/externalConnectionAnnotations');
var resizableEquipment = require('./helpers/resizableEquipment');
var gridEquipmentNode = require('./helpers/gridEquipmentNode');
var svgGeometry = require('./helpers/svgGeometry');
var svgGridSizing = require('./helpers/svgGridSizing');

const $ = go.GraphObject.make;  // for more concise visual tree definitions
const portCoverBrush = $(go.Brush, "Linear", { 0: "#2a2a2a", 1: "#f0f0f0", start: go.Spot.Bottom, end: go.Spot.Top });
const fanGridDefaults = { cols: 3, rows: 3 };

function shouldUseGridShell(nodeData, useGeoPositioning) {
  return !useGeoPositioning && !!(nodeData && (nodeData.gridShell || nodeData.gridShellPrototype));
}

function createGridPortOptions(defaults, isCenterPort) {
  return {
    defaults: defaults || fanGridDefaults,
    isCenterPort: isCenterPort === true,
    isEditing: function() {
      return edit.vm.editing();
    },
    portCoverBrush: portCoverBrush
  };
}

function createPointsLinkedInitializerShape(diagram) {
  return $(go.Shape,
    {
      desiredSize: new go.Size(0, 0),
      fill: null,
      stroke: null
    },
    new go.Binding("data", "pointsLinkedData", function (pointsLinkedData){
      pointsLinkedData.fakeColumns = (pointsLinkedData.pointsLinked || []).map(pointLinked => {
        return {
          in: {
            '@rid': pointLinked.rid,
            minValue: pointsLinkedData.pointsLinkedMinValue,
            maxValue: pointsLinkedData.pointsLinkedMaxValue,
            direction: pointsLinkedData.pointsLinkeddirection || 'clockwise',
            equipmentClass: 'Fan',
            nodeKey: pointsLinkedData.nodeKey,
            formula: pointsLinkedData.formula,
            pointsLinked: pointsLinkedData.pointsLinked,
            value: '0'
          }
        }
      });
      pointsLinkedData.fakeColumns.forEach(fakeColumn => {
        if (fakeColumn && fakeColumn.in && fakeColumn.in['@rid']) {
          if (
            !diagram.model.modelData[`${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`] &&
            diagram.model.modelData[`${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`] != 0
          ) {
            diagram.model.commit(function(mod) {
              mod.set(mod.modelData, `${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`, '0');
            });
            if(!edit.vm.editing()) {
              const pointSubscriberObj = diagram && (diagram.pointSubscriber || diagram.pointSubscriberObj);
              if (pointSubscriberObj) {
                pointSubscriberObj.subscribe({column: fakeColumn}, diagram);
              }
            }
          }
        }
      });

      return pointsLinkedData.fakeColumns;
    })
  );
}

function createFanContextMenu(submitCallback) {
  return edit.vm.editing() ? $("ContextMenu",
    $("ContextMenuButton",
      $(go.TextBlock, "Edit Equipment"),
      {
        click: (e, obj) => {
          editCustomEquipmentModal.editDialogue({...obj.part.data}, { submitCallback: submitCallback, delete: true })
          m.redraw();
        }
      }
    ),
    $("ContextMenuButton",
      $(go.TextBlock, "Copy Bindings"),
      {
        click: (e, obj) => {
          window.latestBindingData = null;
          window.latestBindingData = {
            originRid: obj.part.data.key
          };
          localStorage.setItem("gojsBindingClipboard", JSON.stringify(window.latestBindingData));
          bindingChannel.postMessage({
            type: "copyBinding",
            data: window.latestBindingData
          });
          m.redraw();
        }
      }
    ),
    $("ContextMenuButton",
      new go.Binding("visible", "", () => {
        return !window.latestBindingData || Object.keys(window.latestBindingData).length === 0 ? false : true
      }),
      $(go.TextBlock, "Paste Bindings"),
      {
        click: async (e, obj) => {
          let url = `/api/v1/diagram/${obj.part.data.key.slice(1)}/pastebindings`;
          await loaders.requestWithLoader({
            url,
            method: "PUT",
            body: {
              originRid: window.latestBindingData.originRid,
            }
          })
          .then((response) => {
            return submitCallback();
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            window.latestBindingData = null;
            localStorage.removeItem("gojsBindingClipboard");
          })
        }
      }
    ),
    $("ContextMenuButton",
      $(go.TextBlock, "Edit Permissions"),
      {
        click: (e, obj) => {
          m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}/permissions`)
        }
      }
    )
  ) : null;
}

function fanTemplate(map, useGeoPositioning, submitCallback, diagram, nodeData) {
  var svgConverted;
  if (nodeData && nodeData.class) {
    if (nodeData.class.includes('Fan')) {
      svgConverted = `
        <svg id="Diagram" xmlns="http://www.w3.org/2000/svg" width="66.73" height="65" viewBox="0 0 66.73 65">
          <!-- Grouped Base Shape & Bottom Section -->
          <g id="background">
            <path d="M37.95,2.84l-.41-.02c-.12,0-.24,0-.36,0-.64,0-1.28,0-1.91,0-.64,0-1.28,0-1.91,0-.16,0-.32,0-.49,0-.31.01-1.04.01-1.65.02-.12.03-2.49.02-2.69.02,0,0-.11,0-.18.01C13.04,3.38,1.77,17.14,1.77,32.36c0,16.42,13.55,29.74,30.26,29.74,15.63,0,28.5-11.65,30.09-26.6h3.13V3.02l-27.3-.18Z"
              fill="#565656" stroke="#eee" stroke-width="1.46px"/>
            
            <!-- Bottom Section (Static) -->
            <path d="M12.17,34.12c0-10.67,8.88-19.31,19.76-19.31s19.7,8.64,19.76,19.31"
              fill="#333" stroke-width="0px"/>
          </g>

          ${
            nodeData.hideRotator == 'true' ? '' : `
            <!-- Smooth Full Circular Animated Stroke -->
              <path d="M9.55,34.12a22,22 0 1,1 44.78,0a22,22 0 1,1 -44.78,0"
                stroke="${nodeData.rotatorColor ? nodeData.rotatorColor : '#ccc'}" 
                stroke-width="3" 
                fill="none" 
                id="animated-stroke"
                stroke-dasharray="${nodeData.rotatorDashArray ? nodeData.rotatorDashArray : '5,5'}"
                stroke-dashoffset="20">
              </path>
            `
          }
          

          <g id="foreground">
            <!-- Refined Masking Path (Now Perfectly Inside the Base Shape) -->
            <path d="M3,35c0,14,12,25,29,25s29-11,29-25H3Z" 
              fill="#565656" stroke-width="0px"/>
            <!-- Transparent Background Rect -->
            <rect width="66.73" height="65" fill="none" stroke-width="0px"/>
          </g>
        </svg>
        `;
    } else {
    svgConverted = `
        <svg id="Diagram" xmlns="http://www.w3.org/2000/svg" width="66.73333303" height="65" viewBox="0 0 66.73333303 65">
          <g id="background">
            <polygon points="2.45128139 63.99085024 33.36632045 33.9371393 64.28233607 63.99085024 2.45128139 63.99085024" style="fill: #414042; stroke-width: 0px;"/>
            <path d="M33.36668666,35.33197573l28.45178223,27.65863037H4.9148434l28.45184326-27.65863037M33.36668666,32.54266909L-.01179234,64.9906061h66.75689697l-33.37841797-32.44793701h0Z" style="fill: #58595b; stroke-width: 0px;"/>
            <path d="M31.81260951,63.9996393c-16.99023438,0-30.8125-14.15527344-30.8125-31.55371094C1.00010951,15.71350649,13.10362514,1.6793268,27.98155482,1.16077211l.16894531-.01171875.45507812-.00195312c1.63183594,0,2.17382812-.00878906,2.40136719-.02636719.63964844-.00097656,1.39550781-.00585938,1.71777344-.01757812l.46972656.00878906c.66894531.0078125,1.34375.00878906,2.01855469.00878906s1.34960938-.00097656,2.02441406-.00878906l.38378906-.00488281.359375.02246094,27.75292969.1953125v33.55761719h-3.18847656l-.09277344.89746094c-1.65039062,16.08789062-14.82226562,28.21972656-30.63964844,28.21972656Z" style="fill: #414042; stroke-width: 0px;"/>
            <path d="M32.69749721,2.10486391c.16394043.00372314.3269043.00653076.480896.00732422.63446045.00689697,1.26879883.00866699,1.90325928.00866699h.18035889c.66247559-.00042725,1.32489014-.00091553,1.99163818-.00872803l.30871582-.00415039.36230469.02050781.04943848.00280762.04949951.00030518,26.7097168.18597412v31.56481934h-3.09179688l-.1842041,1.79595947c-1.59747314,15.5758667-14.34204102,27.32165527-29.64508057,27.32165527-16.4385376,0-29.81225586-13.70672607-29.81225586-30.55456543C1.99998744,16.24536684,13.67070277,2.65985659,28.01597865,2.16101625l.04180908-.00146484.04174805-.00317383.11065674-.0088501.37884521.00018311c1.53356934,0,2.15356445-.00628662,2.46838379-.02734375.60211182-.00134277,1.29278564-.00543213,1.64007568-.01550293M32.68864711.10413149c-.32415771.01165771-1.09631348.01531982-1.73309326.01641846-.09686279.02435303-1.58520508.02716064-2.36651611.02716064-.23699951,0-.40887451-.00024414-.45715332-.00024414-.00341797,0-.12011719.00976562-.1854248.01477051C11.84404262.72217348-.00001256,15.78650454-.00001256,32.44544008-.00001256,50.42493227,14.24278529,65.00000551,31.8122433,65.00000551c16.43469238,0,29.9564209-12.75415039,31.63464355-29.11761475h3.28643799V.33148745l-28.69580078-.1998291-.4319458-.02441406c-.12664795.00164795-.253479.0032959-.37994385.00506592-.6708374.00787354-1.34185791.00811768-2.01287842.00854492h-.13110352c-.62719727,0-1.25427246-.00170898-1.88146973-.00854492-.17034912-.00091553-.34094238-.00415039-.51153564-.00817871h0Z" style="fill: #58595b; stroke-width: 0px;"/>
            <polyline points="58.66682138 28.77658145 58.66682138 34.41342397 65.33587934 34.41342397 65.33587934 1.42023462 58.66682138 1.42023463 58.66682138 8.8646565" style="fill: #414042; stroke: #58595b; stroke-miterlimit: 10; stroke-width: 2px;"/>
          </g>

          ${
            nodeData.hideRotator == 'true' ? '' : `
            <!-- Smooth Full Circular Animated Stroke -->
              <path d="M9.55,34.12a22,22 0 1,1 44.78,0a22,22 0 1,1 -44.78,0"
                stroke="${nodeData.rotatorColor ? nodeData.rotatorColor : '#ccc'}" 
                stroke-width="3" 
                fill="none" 
                id="animated-stroke"
                stroke-dasharray="${nodeData.rotatorDashArray ? nodeData.rotatorDashArray : '5,5'}"
                stroke-dashoffset="20">
              </path>
            `
          }

          <g id="foreground">
          <circle cx="31.70297169" cy="32.5" r="8.52630859" style="fill: #6d6e71; stroke-width: 0px;"/>
          <circle cx="31.70297169" cy="48.76663939" r="3.144692" style="fill: #6d6e71; stroke-width: 0px;"/>
          <circle cx="31.70297169" cy="16.23336061" r="3.144692" style="fill: #6d6e71; stroke-width: 0px;"/>
          <circle cx="47.96961108" cy="32.5" r="3.144692" style="fill: #6d6e71; stroke-width: 0px;"/>
          <circle cx="15.43633231" cy="32.5" r="3.144692" style="fill: #6d6e71; stroke-width: 0px;"/>
          </g>
        </svg>
      `;
    } 
  }

  // Validate and replace if custom SVG data exists
  if (
    nodeData && 
    nodeData.svgBackground && 
    nodeData.svgBackground.trim() !== "" &&
    nodeData.svgBackgroundConverted &&
    nodeData.svgBackgroundConverted.trim() !== ""
  ) {
    // Replace the entire <g id="background"> ... </g> with nodeData.svgBackgroundConverted
    svgConverted = svgConverted.replace(/<g id="background">[\s\S]*?<\/g>/, nodeData.svgBackgroundConverted);
  }
  
  if (
    nodeData && 
    nodeData.svgForeground && 
    nodeData.svgForeground.trim() !== "" &&
    nodeData.svgForegroundConverted &&
    nodeData.svgForegroundConverted.trim() !== ""
  ) {
    // Replace the entire <g id="foreground"> ... </g> with nodeData.svgForegroundConverted
    svgConverted = svgConverted.replace(/<g id="foreground">[\s\S]*?<\/g>/, nodeData.svgForegroundConverted);
  }

  var nodeDrawing = new go.Panel({ 
    row: 1, 
    column: 1, 
    name: "body" 
  });  // this Panel holds all of the Shapes for the drawing
  var xmldoc = new DOMParser().parseFromString( svgConverted, "text/xml");
  var paths = xmldoc.getElementsByTagName("path");
  //var wheelDrawing = new go.Panel("Spot");
  for (var i = 0; i < paths.length; i++) {
    // represent each SVG path by a Shape of type Path with its own fill and stroke
    var path = paths[i];
    var shape = new go.Shape();
    var panel = new go.Panel("Spot");

    var stroke = path.getAttribute("stroke");
    if (typeof stroke === "string" && stroke !== "none") {
      shape.stroke = stroke;
    } else {
      shape.stroke = null;
    }

    var strokewidth = parseFloat(path.getAttribute("stroke-width"));
    if (!isNaN(strokewidth)) shape.strokeWidth = strokewidth;
    

    var id = path.getAttribute("id");
    if (typeof id === "string") shape.name = id;

    var fill = path.getAttribute("fill");
    if (typeof fill === "string") {
      shape.fill = (fill === "none") ? null : fill;
    }

    // convert the path data string into a go.Geometry
    var data = path.getAttribute("d");
    var geometry = svgGeometry.parseSvgPathGeometry(data, {
      element: path,
      context: 'fanTemplate'
    });
    if (!geometry) continue;
    shape.geometry = geometry;

    // Extract stroke-dasharray and stroke-dashoffset from the SVG path
    var strokeDashArray = path.getAttribute("stroke-dasharray");
    if (typeof strokeDashArray === "string") {
      shape.strokeDashArray = strokeDashArray.split(",").map(Number);
    }

    var strokeDashOffset = parseFloat(path.getAttribute("stroke-dashoffset"));
    if (!isNaN(strokeDashOffset)) {
      shape.strokeDashOffset = strokeDashOffset;
    }

    panel.add(shape);
    nodeDrawing.add(panel);
  }
  var scaledNodeDrawing = nodeDrawing.copy();
  var rawAnimatedStroke = nodeDrawing.findObject("animated-stroke");
  var scaledAnimatedStroke = scaledNodeDrawing.findObject("animated-stroke");
  var useGridShell = shouldUseGridShell(nodeData, useGeoPositioning);
  if (!useGridShell) {
    nodeDrawing.bind(resizableEquipment.createSizedVisibilityBinding(false));
    if (rawAnimatedStroke) {
      rawAnimatedStroke.bind(resizableEquipment.createSizedNameBinding("animated-stroke", false));
    }
    if (scaledAnimatedStroke) {
      scaledAnimatedStroke.bind(resizableEquipment.createSizedNameBinding("animated-stroke", true));
    }
  }

  if (useGridShell) {
    var gridDefaults = svgGridSizing.getGridDefaultsForSvg(svgConverted, fanGridDefaults);
    return $(go.Node, "Spot",
      {
        locationSpot: go.Spot.TopLeft,
        locationObjectName: "BODY",
        selectionObjectName: "BODY",
        selectionAdornmentTemplate: gridEquipmentNode.createSelectionAdornmentTemplate(),
        resizeObjectName: "BODY",
        resizeCellSize: gridEquipmentNode.getResizeCellSize(),
        contextMenu: createFanContextMenu(submitCallback),
        doubleClick: function(e, obj) {
          if (!edit.vm.editing()) {
            m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}`)
          }
        }
      },
      new go.Binding("cursor", "", data => {
        return edit.vm.editing() ? "pointer" : "default";
      }),
      new go.Binding("deletable", "", data => {
        return edit.vm.editing();
      }),
      new go.Binding("selectable", "", data => {
        return edit.vm.editing();
      }),
      new go.Binding("movable", "", data => {
        return edit.vm.editing();
      }),
      new go.Binding("resizable", "", data => {
        return edit.vm.editing();
      }),
      new go.Binding("location", "latlong", data => {
        return new go.Point(data[0], data[1]);
      }),
      $(go.Panel, "Spot",
        {
          name: "BODY",
          alignment: go.Spot.Center,
          alignmentFocus: go.Spot.Center
        },
        gridEquipmentNode.createBodySizeBinding(gridDefaults),
        $(go.Panel, "Viewbox",
          {
            stretch: go.GraphObject.Fill
          },
          scaledNodeDrawing
        ),
        createPointsLinkedInitializerShape(diagram)
      ),
      gridEquipmentNode.createSpotPortPanel("leftArray", "left", createGridPortOptions(gridDefaults)),
      gridEquipmentNode.createSpotPortPanel("topArray", "top", createGridPortOptions(gridDefaults)),
      gridEquipmentNode.createSpotPortPanel("rightArray", "right", createGridPortOptions(gridDefaults)),
      gridEquipmentNode.createSpotPortPanel("bottomArray", "bottom", createGridPortOptions(gridDefaults)),
      gridEquipmentNode.createSpotPortPanel("centerArray", "center", createGridPortOptions(gridDefaults, true)),
      createExternalConnectionAnnotations()
    );
  }

  var nodePart = $(go.Node, "Spot",
  {
    locationSpot: go.Spot.TopLeft,
    resizeObjectName: "BODY",
    resizeCellSize: resizableEquipment.getResizeCellSize(),
    contextMenu: createFanContextMenu(submitCallback),
    doubleClick: function(e, obj) {
      // Navidate to the equipment detail page in browse mode
      if (!edit.vm.editing()) {
        m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}`)
      }
    }
  },
  new go.Binding("cursor", "", data => {
    return edit.vm.editing() ? "pointer" : "default";
  }),
  new go.Binding("deletable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("selectable", "", data => {
    return edit.vm.editing();
  }),
  new go.Binding("movable", "", data => {
    return edit.vm.editing();
  }),
  resizableEquipment.createResizableBinding(),
  useGeoPositioning ? 
    new go.Binding("location", "latlong", data => {
      const pos = map.project(data, map.getZoom());
      return new go.Point(pos.x, pos.y);
    }).makeTwoWay((pt, data) => {
      if (updatingGoJs) {
        return data.latlong; // no-op
      } else {
        const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
        return [ll.lat, ll.lng];
      }
    })
  : 
    new go.Binding("location", "latlong", data => {
      return new go.Point(data[0], data[1]);
    }),
  $(go.Panel, "Table",
    $(go.Panel, "Auto",
      {
        row: 1, column: 1, name: "BODY"
      }, 
      ...resizableEquipment.createBodySizeBindings(),
      nodeDrawing,
      $(go.Panel, "Viewbox",
        {
          stretch: go.GraphObject.Fill
        },
        resizableEquipment.createSizedVisibilityBinding(true),
        scaledNodeDrawing
      ),
      $(go.Shape,
        {
          desiredSize: new go.Size(0, 0),
          fill: null,
          stroke: null
        },
        new go.Binding("data", "pointsLinkedData", function (pointsLinkedData){
          pointsLinkedData.fakeColumns = (pointsLinkedData.pointsLinked || []).map(pointLinked => {
            return {
              in: {
                '@rid': pointLinked.rid,
                minValue: pointsLinkedData.pointsLinkedMinValue,
                maxValue: pointsLinkedData.pointsLinkedMaxValue,
                direction: pointsLinkedData.pointsLinkeddirection || 'clockwise',
                equipmentClass: 'Fan',
                nodeKey: pointsLinkedData.nodeKey,
                formula: pointsLinkedData.formula,
                pointsLinked: pointsLinkedData.pointsLinked,
                value: '0'
              }
            }
          });
          pointsLinkedData.fakeColumns.forEach(fakeColumn => {
            if (fakeColumn && fakeColumn.in && fakeColumn.in['@rid']) {
              if (
                !diagram.model.modelData[`${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`] &&
                diagram.model.modelData[`${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`] != 0
              ) {
                diagram.model.commit(function(mod) {
                  mod.set(mod.modelData, `${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`, '0');
                });
                if(!edit.vm.editing()) {
                  const pointSubscriberObj = diagram && (diagram.pointSubscriber || diagram.pointSubscriberObj);
                  if (pointSubscriberObj) {
                    pointSubscriberObj.subscribe({column: fakeColumn}, diagram);
                  }
                }
              }
            }
          });

          return pointsLinkedData.fakeColumns;
        })
      )
    ),
    $(go.Panel, "Vertical",
      new go.Binding("itemArray", "leftArray"),
      {
        row: 1, column: 0,
        itemTemplate:
          $(go.Panel,
            {
              _side: "left",  // internal property to make it easier to tell which side it's on
              fromSpot: go.Spot.Left, 
              toSpot: go.Spot.Left,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId", function(portId) {
              return portId.split('_')[1]
            }),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output";
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input";
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(diagramConfiguration.calculateCellHeight() / 2, 0)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ), 
    $(go.Panel, "Horizontal",
      new go.Binding("itemArray", "topArray"),
      {
        row: 0, column: 1,
        itemTemplate:
          $(go.Panel,
            {
              _side: "top",
              fromSpot: go.Spot.Top, 
              toSpot: go.Spot.Top,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId", function(portId) {
              return portId.split('_')[1]
            }),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output";
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input";
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ),
    $(go.Panel, "Vertical",
      new go.Binding("itemArray", "rightArray"),
      {
        row: 1, column: 2,
        itemTemplate:
          $(go.Panel,
            {
              _side: "right",
              fromSpot: go.Spot.Right, 
              toSpot: go.Spot.Right,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId", function(portId) {
              return portId.split('_')[1]
            }),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output";
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input";
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(diagramConfiguration.calculateCellHeight() / 2, 0)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ),
    $(go.Panel, "Horizontal",
      new go.Binding("itemArray", "bottomArray"),
      {
        row: 2, column: 1,
        itemTemplate:
          $(go.Panel,
            {
              _side: "bottom",
              fromSpot: go.Spot.Bottom, 
              toSpot: go.Spot.Bottom,
              cursor: "pointer",
              //contextMenu: portMenu
            },
            new go.Binding("portId", "portId", function(portId) {
              return portId.split('_')[1]
            }),
            new go.Binding("category", "category"),
            new go.Binding("fromLinkable", "type", function(type) {
              // Set fromLinkable to true if the node's type is "input"
              return type === "output";
            }),
            new go.Binding("toLinkable", "type", function(type) {
              // Set toLinkable to true if the node's type is "output"
              return type === "input";
            }),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2)
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )  // end itemTemplate
      }
    ),
    $(go.Panel, "Horizontal",
      new go.Binding("itemArray", "centerArray"),
      {
        row: 1, column: 1, // Adjust the row and column if needed
        itemTemplate:
          $(go.Panel, // or "Horizontal" depending on your layout
            {
              alignment: go.Spot.Center,
              fromSpot: go.Spot.AllSides,
              toSpot: go.Spot.AllSides,
              fromLinkable: true,
              toLinkable: true,
              fromMaxLinks: 1,
              toMaxLinks: 1,
              visible: edit.vm.editing() ? true : false,
            },
            new go.Binding("portId", "portId", function(portId) {
              return portId.split('_')[1]
            }),
            new go.Binding("category", "category"),
            $(go.Shape, "Rectangle",
              {
                stroke: null, strokeWidth: 0,
                desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2),
              },
              new go.Binding("fill", "portColor", function(portColor) {
                if(!edit.vm.editing()) {
                  return portCoverBrush;
                } else {
                  return portColor
                }
              }))
          )
      },
    ),
    createExternalConnectionAnnotations()
  )
)

return nodePart
}

module.exports = fanTemplate;
